import { useCallback } from 'react';
import { useAppContext } from '../Contexts/AppContext';
import {
  getFeedbackPageLoaded,
  getFeedbackGenericClick,
} from '@wix/bi-logger-get-feedback/v2';

import { EDITOR_TYPE } from '@src/utils/constants';

const getEditorTypeForBi = (editorType: string) => {
  switch (editorType) {
    case EDITOR_TYPE.STUDIO:
      return 'studio';
    case EDITOR_TYPE.EDITOR:
      return 'editor';
    case EDITOR_TYPE.EDITORX:
      return 'editorx';
    case EDITOR_TYPE.ADI:
      return 'adi';
    default:
      return 'unknown';
  }
};

const useBiLogger = () => {
  const {
    state: {
      editorType,
      user,
      pageId,
      currentBreakPoint,
      metaSiteId,
      biLogger,
    },
  } = useAppContext();

  const logPageLoaded = useCallback(() => {
    biLogger?.report(
      getFeedbackPageLoaded({
        ...(user.contactId && { contact_id: user.contactId }),
        breakpoint: JSON.stringify(currentBreakPoint),
        editor_version: getEditorTypeForBi(editorType),
        page_id: pageId,
        feedback_user_type: 'client',
      }),
    );
  }, [editorType, user, currentBreakPoint, pageId, biLogger]);

  const logGenericClick = useCallback(
    ({
      click_type,
      comment_has_email = undefined,
      comment_id = undefined,
      response_id = undefined,
      text = undefined,
    }: {
      click_type: string;
      comment_has_email?: boolean;
      comment_id?: string;
      response_id?: string;
      text?: string;
    }) => {
      biLogger?.report(
        getFeedbackGenericClick({
          ...(user.contactId && { contact_id: user.contactId }),
          feedback_user_type: 'client',
          breakpoint: JSON.stringify(currentBreakPoint),
          editor_version: getEditorTypeForBi(editorType),
          page_id: pageId,
          msid: metaSiteId,
          click_type,
          comment_id,
          comment_has_email,
          response_id,
          text,
        }),
      );
    },
    [editorType, user, currentBreakPoint, pageId, metaSiteId, biLogger],
  );

  return {
    logPageLoaded,
    logGenericClick,
  };
};

export default useBiLogger;
